module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 380
// module chunks = 0